import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api'
import { DigitalProductInterface } from 'modules/digital-product/types/digital-product-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { digitalProductDependencies } from '../constants/digital-product-dependencies'

export function useDigitalProduct(digitalProductId?: number | null) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, DigitalProductInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    () => [`${DIGITAL_PRODUCT_API}/${digitalProductId}`, ...digitalProductDependencies],
    fetcher,
    {},
    !!user && !!digitalProductId,
  )
}
